const validate = {
  isNumAndPoint(str) {
    // 只能输入数字
    const reg = /^[0-9]*$/
    return reg.test(str)
  },
}

export default validate
